const IMAGES = [
    {
        url: "https://images.unsplash.com/photo-1592659762303-90081d34b277?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxjaXJjdWl0JTIwYm9hcmQlMjBtYWNyb3xlbnwwfHx8fDE3ODk4MTE5NDl8MA&ixlib=rb-4.1.0&q=85",
        bay: "BAY_A1 // CIRCUITRY",
        caption: "Raspberry Pi bus and motor controllers",
        alt: "Macro photograph of Raspberry Pi circuitry",
    },
    {
        url: "https://images.unsplash.com/photo-1611117775350-ac3950990985?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHwzZCUyMHByaW50ZXIlMjBwcmludGluZ3xlbnwwfHx8fDE3ODk4MTE5NDl8MA&ixlib=rb-4.1.0&q=85",
        bay: "BAY_A2 // FABRICATION",
        caption: "PETG structural brackets extrusion",
        alt: "3D printer nozzle extruding chassis components",
    },
    {
        url: "https://images.unsplash.com/photo-1581092335331-5e00ac65e934?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxyb2JvdGljcyUyMHRlY2huaWNhbCUyMGRpYWdyYW18ZW58MHx8fHwxNzg5ODExOTQ5fDA&ixlib=rb-4.1.0&q=85",
        bay: "BAY_B1 // CAD TOPOLOGY",
        caption: "Lobster-adjacent mechanical gripper",
        alt: "CAD wireframe schematic of robot chassis",
    },
    {
        url: "https://images.unsplash.com/photo-1518773553398-650c184e0bb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtb25pdG9yJTIwc2NyZWVucyUyMGNvZGUlMjBkYXJrfGVufDB8fHx8MTc4OTgxMTk0OXww&ixlib=rb-4.1.0&q=85",
        bay: "BAY_B2 // NEURAL BENCH",
        caption: "Local quantized LLM evaluation suite",
        alt: "Nighttime multi-monitor desk running local LLM telemetry",
    },
];

export default function WorkbenchBand() {
    return (
        <section className="py-16 bg-[#e9edf1] border-b border-subtle" data-testid="workbench-band">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between mb-8">
                    <div>
                        <span className="font-mono text-xs text-cyan-600 tracking-widest block uppercase">
                            // Optical Sensor Feed
                        </span>
                        <h2 className="text-2xl font-bold font-display text-slate-900 mt-1">
                            Laboratory Workbench Surfaces
                        </h2>
                    </div>
                    <span className="font-mono text-xs text-slate-500 hidden sm:inline">
                        LIVE CAPTURE: R&amp;D FACILITY 01
                    </span>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {IMAGES.map((img, i) => (
                        <div
                            key={img.bay}
                            data-testid={`workbench-image-${i + 1}`}
                            className="relative rounded border border-subtle overflow-hidden aspect-[4/3] bg-white group"
                        >
                            <img
                                src={img.url}
                                alt={img.alt}
                                loading="lazy"
                                className="absolute inset-0 h-full w-full object-cover opacity-60 saturate-[0.6] group-hover:opacity-85 group-hover:saturate-100 transition-opacity duration-500"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent p-4 flex flex-col justify-end">
                                <span className="font-mono text-[10px] text-cyan-600">{img.bay}</span>
                                <p className="text-xs text-slate-700 font-medium">{img.caption}</p>
                            </div>
                            <div className="absolute top-3 right-3 h-1.5 w-1.5 rounded-full bg-red-500 animate-led" />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
